/**
 * App route paths — use these constants instead of hardcoding URLs.
 * Patient intake + eligibility share `/patient` (`PATIENT_NAV` in location state).
 */
export const ROUTES = {
  LOGIN: '/login',
  /** Patient intake + eligibility — use `PATIENT_NAV` in location state */
  PATIENT_HOME: '/patient',
  /** Experimental AI chat intake + modern result (separate from current flow) */
  PATIENT_AI_INTAKE: '/patient-ai',
  PATIENT_AI_RESULT: '/patient-ai/result',
  /** Provider app versions of intake/result pages (inside private layout/theme) */
  PROVIDER_PATIENT_INTAKE: '/provider/patient-intake',
  PROVIDER_ELIGIBILITY_RESULT: '/provider/eligibility-result',
  DASHBOARD: '/dashboard',
  PATIENTS: '/patients',
  PATIENT_DETAIL: '/patients/:eligibilityCheckId',
  PAYORS: '/payors',
  MASTERS: '/masters',
  /** Provider configuration — NPI & practice state defaults */
  PROVIDER_NPI_LOCATION: '/provider-configuration/npi-location',
  CPT_HCPC: '/cpt-hcpc',
  RULES_ENGINE: '/rules-engine',
  PRIOR_AUTH: '/prior-auth',
  /** Legacy underscore URL — redirects to PRIOR_AUTH */
  PRIOR_AUTH_LEGACY: '/prior_auth',
  SETTINGS: '/settings',
  NOTIFICATIONS: '/notifications',
  DASHBOARD_SETTINGS: '/dashboard-settings',
  CHAT: '/chat',
  AGENTS: '/agents',
} as const

/** Pass as `navigate(ROUTES.PATIENT_HOME, { state: PATIENT_NAV.intake })` etc. */
export const PATIENT_NAV = {
  intake: { patientFlow: 'intake' as const },
  eligibility: { patientFlow: 'eligibility' as const },
} as const

/** Partial create-form fields passed when opening the prior-auth drawer from another page. */
export type PriorAuthCreatePrefill = {
  request_number?: string
  patient_id?: string
  subscriber_id?: string
  payor_id?: string
  provider_name?: string
  provider_npi?: string
  provider_address?: string
}

/** Pass as `navigate(ROUTES.PRIOR_AUTH, { state: PRIOR_AUTH_NAV.create(prefill) })`. */
export const PRIOR_AUTH_NAV = {
  create: (prefill?: PriorAuthCreatePrefill, createStep = 1) => ({
    openCreate: true as const,
    createStep,
    prefill,
  }),
} as const

/** Build a `/patients/:eligibilityCheckId` URL for navigation. */
export function patientDetailPath(eligibilityCheckId: string): string {
  return `/patients/${encodeURIComponent(eligibilityCheckId)}`
}
